import { isMSWEnabled } from "appConfiguration";

if (isMSWEnabled) {
  // eslint-disable-next-line global-require
  require("./index");
}

export {};
